/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {

  // Remove empty P tags created by WP inside of Accordion and Orbit
  jQuery('.accordion p:empty, .orbit p:empty').remove();

  // Makes sure last grid item floats left
  jQuery('.archive-grid .columns').last().addClass( 'end' );

	// Adds Flex Video to YouTube and Vimeo Embeds
  jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
    if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
      jQuery(this).wrap("<div class='widescreen flex-video'/>");
    } else {
      jQuery(this).wrap("<div class='flex-video'/>");
    }
  });

  // Menu toggle  
  jQuery("#menu_toggle").click(function(e){

    jQuery(this).toggleClass('active');
    jQuery("#mobile_menu").slideToggle();

  });

  jQuery("#tattoo_index").click(function(e){

    if(jQuery(window).width() < 825) {
        jQuery("#menu_toggle").addClass('active');
        jQuery("#mobile_menu").slideDown();
        jQuery(window).scrollTo("#menu-item-655");
        setTimeout(function(){
          jQuery("#menu-item-655 a").click();
        },500);
        e.stopPropagation();
        e.preventDefault();
    }

  });

  jQuery( window ).resize(function() {

    if(jQuery(window).width() >= 825) {
        jQuery("#mobile_menu").slideUp();
    }

  });

});
